import { CHANGESTATUS, SEARCH } from "./actionType";
import { initialState } from "./initialState";

const filterReducer = (state = initialState, action) => {
 switch (action.type) {
  case SEARCH:
   return {
    ...state,
    search: action.payload,
   };
  case CHANGESTATUS:
   return {
    ...state,
    status: action.payload,
   };
  default:
   return state;
 }
};
export default filterReducer;
